exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._149ksFoeZB0NaA_WcW_LBP{font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}", ""]);
// Exports
exports.locals = {
	"senderSummary": "_149ksFoeZB0NaA_WcW_LBP"
};